interface MidCTABannerProps {
  headline?: string;
  sub?: string;
  cta?: string;
}

const MidCTABanner: React.FC<MidCTABannerProps> = ({
  headline = 'Ready to Elevate Your Property?',
  sub = 'Free, no-obligation estimates. $100 off when you sign on consultation day.',
  cta = 'Request a Free Consultation',
}) => (
  <section className="relative py-24 overflow-hidden">
    {/* Cinematic background */}
    <div
      className="absolute inset-0 bg-cover bg-center bg-fixed"
      style={{
        backgroundImage: "url('https://public.readdy.ai/ai/img_res/ca821d46468ab88d1696d7a7dea173b6.jpg')",
      }}
    />
    <div className="absolute inset-0 bg-[#0D0C0B]/86" />
    <div className="gold-separator absolute top-0 left-0 right-0" />
    <div className="gold-separator absolute bottom-0 left-0 right-0" />

    <div className="relative z-10 max-w-4xl mx-auto px-6 text-center reveal">
      {/* Label */}
      <div className="flex items-center justify-center gap-4 mb-8">
        <span className="gold-bar" />
        <span className="text-[#C4A84F] text-[11px] tracking-[0.4em] uppercase font-sans font-medium">
          St. Mary's, Georgia · Camden County
        </span>
        <span className="gold-bar" />
      </div>

      <h2 className="font-serif text-[3rem] md:text-[4.2rem] lg:text-[5rem] text-[#F5F1E8] leading-[0.95] mb-6">
        {headline}
      </h2>
      <p className="text-[#F5F1E8]/80 text-base md:text-lg font-sans mb-12 max-w-lg mx-auto leading-relaxed">
        {sub}
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <a href="#estimate" className="btn-gold px-12 py-5">
          <i className="fa-regular fa-calendar-check text-[11px]" />
          {cta}
        </a>
        <a href="tel:912-409-2031" className="btn-outline-light-strong px-12 py-5">
          <i className="fa-solid fa-phone text-[11px]" />
          912-409-2031
        </a>
      </div>

      {/* Trust strip */}
      <div className="flex flex-wrap justify-center gap-8 mt-14 pt-10 border-t border-white/20">
        {[
          { icon: 'fa-star',             text: '5-Star Google Rated' },
          { icon: 'fa-shield-halved',    text: 'Licensed & Insured' },
          { icon: 'fa-tag',              text: '$100 Off Same-Day Signing' },
          { icon: 'fa-map-location-dot', text: "St. Mary's, GA 31558" },
        ].map((item) => (
          <div key={item.text} className="flex items-center gap-2.5 text-[#F5F1E8]/75 text-[11px] font-sans tracking-wide">
            <i className={`fa-solid ${item.icon} text-[#C4A84F] text-[10px]`} />
            {item.text}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default MidCTABanner;
